import { Box, Stack, Typography } from '@mui/material';
import { _ } from '/@/locale';
import type { useProductComparator } from '../../hooks/product-comparator';
import { useSearchedProducts } from '../../hooks/searched-products';
import ProductCard from '../product-card';

type LatestSearchedProductsProps = Pick<
    ReturnType<typeof useProductComparator>,
    'getTypeOfIds' | 'setSelectedType' | 'selectProduct' | 'isSelected' | 'selectedType' | 'selectedProducts'
> & {
    allProducts: any[];
};

const LatestSearchedProducts = ({
    getTypeOfIds,
    setSelectedType,
    selectProduct,
    isSelected,
    selectedType,
    selectedProducts,
    allProducts,
}: LatestSearchedProductsProps) => {
    // Searched Products
    const { searchedProducts } = useSearchedProducts();

    const searchedProductsList = searchedProducts
        .slice(0, 4)
        .map((savedProduct) =>
            allProducts.find(
                (p) =>
                    savedProduct.productId === p.id &&
                    savedProduct.slug === p.slugLabel &&
                    savedProduct.type === p.catalogType
            )
        )
        .filter(Boolean);

    if (!searchedProductsList.length) return null;

    return (
        <Stack spacing={2}>
            <Typography color='primary' variant='h6'>
                {_('Últimas busquedas')}
            </Typography>
            <Box
                sx={{
                    overflowX: 'auto',
                    display: 'grid',
                    gridTemplateColumns: {
                        xs: 'repeat(1, 1fr)',
                        md: 'repeat(2, 1fr)',
                        lg: 'repeat(4, 1fr)',
                    },
                    gridAutoRows: '1fr',
                    gap: 2,
                }}
                maxWidth='100%'
            >
                {searchedProductsList?.map(
                    (
                        {
                            imageSrc,
                            name,
                            description,
                            id,
                            chips,
                            technologies,
                            typeLabel,
                            catalogType,
                            slugLabel,
                            newProduct,
                            brand,
                            type,
                        },
                        i
                    ) => {
                        return (
                            <Stack key={id} minWidth='200px'>
                                <ProductCard
                                    id={id}
                                    imageSrc={imageSrc}
                                    name={name}
                                    description={description}
                                    typeLabel={typeLabel}
                                    chips={chips}
                                    technologies={technologies}
                                    selectProduct={() => {
                                        selectProduct({ id });
                                        setSelectedType(catalogType);
                                    }}
                                    isSelected={isSelected({ id })}
                                    disabled={
                                        !(!selectedType || (selectedType && catalogType === selectedType)) ||
                                        (selectedProducts.size >= 4 && !isSelected({ id }))
                                    }
                                    type={type}
                                    catalogType={catalogType}
                                    slugLabel={slugLabel}
                                    newProduct={newProduct}
                                    brand={brand}
                                />
                            </Stack>
                        );
                    }
                )}
            </Box>
        </Stack>
    );
};

export default LatestSearchedProducts;
